import { ClientCatalogItemViewModel } from '@common/model/client/catalog/item/clientCatalogItemViewModel';
import { CityViewModel } from '@common/model/location/cityViewModel';
import { MOBILE_BREAKPOINT_THRESHOLD, SxProps } from '@cp/ds/src/theme';
import { format } from 'date-fns';
import { VACANCY_EDIT_DATE_FORMAT, VacancyEditFormProps } from 'src/entities/vacancy';
export * from './events';

export const mapViewModelToFormValues = (viewModel: ClientCatalogItemViewModel): VacancyEditFormProps['defaultValues'] => {
  const { careerId, startedAt, endedAt, children, city, childWithDisabilities, regularSpecialist, translation, location, address } =
    viewModel;

  return {
    careerId,
    date: startedAt ? format(new Date(startedAt), VACANCY_EDIT_DATE_FORMAT) : undefined,
    startedAt,
    endedAt,
    city: city as CityViewModel,
    address: { address, location },
    children,
    translations: [{ title: translation?.title, languageCode: translation?.languageCode, description: translation?.description }],
    childWithDisabilities,
    regularSpecialist,
  };
};

export const contentContanerSx: SxProps = {
  px: { [MOBILE_BREAKPOINT_THRESHOLD]: 5 },
  minWidth: { [MOBILE_BREAKPOINT_THRESHOLD]: 495 },
};
